import React, { useState, useEffect } from 'react';
import propertyService from './services/propertyService';

const TestAPI = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [directTest, setDirectTest] = useState('');
  const [authTest, setAuthTest] = useState('');

  const testAPI = async () => {
    setLoading(true);
    setError(null);
    console.log('🧪 Testing Properties API...');

    try {
      // Test with your specific builder ID
      const yourBuilderId = "7104f775-5355-4e3d-8542-a34f179aec9f";
      console.log('🧪 Testing for builder ID:', yourBuilderId);

      // First test all properties
      console.log('🧪 Step 1: Getting all properties...');
      const allResponse = await propertyService.getProperties();
      console.log('🧪 All properties response:', allResponse);

      if (allResponse.success && allResponse.data) {
        console.log('🧪 Step 2: Found', allResponse.data.length, 'total properties');

        // Test builder-specific filtering
        console.log('🧪 Step 3: Testing builder-specific filtering...');
        const builderResponse = await propertyService.getPropertiesByBuilder(yourBuilderId);
        console.log('🧪 Builder properties response:', builderResponse);

        if (builderResponse.success && builderResponse.data) {
          setProperties(builderResponse.data);
          console.log('✅ API test successful! Found', builderResponse.data.length, 'properties for your builder');
        } else {
          setError(builderResponse.error || 'Builder filtering failed');
        }
      } else {
        setError(allResponse.error || 'API call failed');
        console.log('❌ API test failed:', allResponse.error);
      }
    } catch (err) {
      console.error('🧪 Test API Error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const testDirectAPI = async () => {
    setDirectTest('Testing...');
    try {
      console.log('🧪 Testing direct API call...');
      const response = await fetch('/api/properties', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });
      console.log('🧪 Direct API response status:', response.status);

      if (response.ok) {
        const data = await response.json();
        console.log('🧪 Direct API data:', data);
        setDirectTest(`✅ Direct API works! Found ${data.data?.length || 0} properties`);
      } else {
        const error = await response.text();
        console.log('🧪 Direct API error:', error);
        setDirectTest(`❌ Direct API failed: ${response.status} ${response.statusText}`);
      }
    } catch (err) {
      console.log('🧪 Direct API exception:', err);
      setDirectTest(`❌ Direct API exception: ${err.message}`);
    }
  };

  const testWithAuth = () => {
    // Set a dummy auth token for testing (you should replace this with a real token)
    const dummyToken = 'test-token-replace-with-real-one';
    localStorage.setItem('authToken', dummyToken);
    setAuthTest('✅ Test auth token set in localStorage');
    console.log('🧪 Set test auth token in localStorage');
  };

  const clearAuth = () => {
    localStorage.removeItem('authToken');
    setAuthTest('❌ Auth token cleared from localStorage');
    console.log('🧪 Cleared auth token from localStorage');
  };

  const checkCurrentAuth = () => {
    const token = localStorage.getItem('authToken');
    setAuthTest(token ? `✅ Auth token exists: ${token.substring(0, 20)}...` : '❌ No auth token found');
    console.log('🧪 Current auth token:', token ? token.substring(0, 20) + '...' : 'None');
  };

  useEffect(() => {
    checkCurrentAuth();
    testAPI();
    testDirectAPI();
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1>🧪 Properties API Test Page</h1>

      <div style={{ marginBottom: '20px' }}>
        <button
          onClick={testAPI}
          disabled={loading}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: loading ? 'not-allowed' : 'pointer',
            marginRight: '10px'
          }}
        >
          {loading ? 'Testing API...' : 'Test Properties API'}
        </button>

        <button
          onClick={testDirectAPI}
          style={{
            padding: '10px 20px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginRight: '10px'
          }}
        >
          Test Direct API
        </button>

        <button
          onClick={checkCurrentAuth}
          style={{
            padding: '10px 20px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Check Auth
        </button>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <button
          onClick={testWithAuth}
          style={{
            padding: '8px 16px',
            backgroundColor: '#ffc107',
            color: 'black',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginRight: '10px'
          }}
        >
          Set Test Auth
        </button>

        <button
          onClick={clearAuth}
          style={{
            padding: '8px 16px',
            backgroundColor: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Clear Auth
        </button>
      </div>

      {authTest && (
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '10px',
          borderRadius: '5px',
          marginBottom: '20px',
          border: '1px solid #dee2e6'
        }}>
          <strong>Auth Status:</strong> {authTest}
        </div>
      )}

      {directTest && (
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '10px',
          borderRadius: '5px',
          marginBottom: '20px',
          border: '1px solid #dee2e6'
        }}>
          <strong>Direct API Test:</strong> {directTest}
        </div>
      )}

      {loading && <p>🔄 Loading...</p>}

      {error && (
        <div style={{
          color: 'red',
          backgroundColor: '#ffe6e6',
          padding: '10px',
          borderRadius: '5px',
          marginBottom: '20px'
        }}>
          <strong>❌ Error:</strong> {error}
        </div>
      )}

      {properties.length > 0 && (
        <div>
          <h2>✅ API Success! Found {properties.length} properties:</h2>
          <div style={{ display: 'grid', gap: '10px' }}>
            {properties.map((property, index) => (
              <div
                key={property.id || index}
                style={{
                  border: '1px solid #ddd',
                  padding: '15px',
                  borderRadius: '5px',
                  backgroundColor: '#f9f9f9'
                }}
              >
                <h3 style={{ margin: '0 0 10px 0', color: '#007bff' }}>
                  {property.property_title || property.name || 'Untitled Property'}
                </h3>
                <p><strong>ID:</strong> {property.id}</p>
                <p><strong>Type:</strong> {property.property_type}</p>
                <p><strong>Status:</strong> {property.status}</p>
                <p><strong>Price:</strong> ₹{property.price}</p>
                <p><strong>Location:</strong> {property.city}, {property.state}</p>
                <p><strong>Address:</strong> {property.address}</p>
                {property.images && property.images.length > 0 && (
                  <p><strong>Images:</strong> {property.images.length} images</p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {!loading && !error && properties.length === 0 && (
        <div style={{
          color: '#666',
          backgroundColor: '#f0f0f0',
          padding: '10px',
          borderRadius: '5px',
          marginBottom: '20px'
        }}>
          ℹ️ No properties found or API not yet called
        </div>
      )}

      <div style={{ marginTop: '30px', fontSize: '14px', color: '#666' }}>
        <p><strong>Instructions:</strong></p>
        <ol>
          <li>Open Browser Developer Console (F12)</li>
          <li>Check the Console tab for API debug logs</li>
          <li>Look for 🔍, 🔄, ✅ and ❌ emoji logs</li>
          <li>If you see authentication errors, login first at <a href="/BuilderLogin">/BuilderLogin</a></li>
        </ol>
      </div>
    </div>
  );
};

export default TestAPI;